module.exports = __webpack_public_path__ + "static/media/seta-azul.e245f19b.svg";